// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__Gze82","logoContainer":"Header_logoContainer__Ca1SE","logoImg":"Header_logoImg__r09WX"};